export default {"src":"/_next/static/media/capacitorjs.ef35ab1a.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};